import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

// Active coldrooms for placement pickers (rebin capture, rebin stock-sheet
// placement, pallet placement). Extracted so the identical query isn't
// copy-pasted per call site — see CLAUDE.md component-reuse rule.
export function useActiveColdrooms() {
  return useQuery({
    queryKey: ['coldrooms-active'],
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('coldrooms').select('coldroom_id, code, name')
        .eq('is_active', true).order('sort_order').order('code')
      if (error) throw error
      return data as { coldroom_id: string; code: string; name: string }[]
    },
  })
}
